module.exports = __webpack_public_path__ + "static/media/notecards.c6899b30.png";